/* eslint-disable */
export default {
  doNotCall: 'Não ligar',
} as const;

// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
